<template>
    <div class="bottom-video-banner_ext" />
</template>
<script>
export default {};
</script>
